import {ADD_PRODUIT, CHANGE_FORMAT_SPOT, CLEAR, REMOVE_PRODUIT} from "../actions/panier";

export default function (
    state = {
      panier: [],
      semainesOccupees: [],
      formatSpot: 30
    },
    action
) {
  switch (action.type) {
    case ADD_PRODUIT:
      return {
        ...state,
        panier: state.panier.concat([action.produitPanier]),
        semainesOccupees: state.semainesOccupees.concat([action.produitPanier.semaine])
      };
    case REMOVE_PRODUIT:
      return {
        ...state,
        panier: state.panier.filter(v => !v.equals(action.produitPanier)),
        semainesOccupees: state.semainesOccupees.filter(
            v => v.code !== action.produitPanier.semaine.code
        )
      };
    case CLEAR:
      return {...state, panier: [], semainesOccupees: []};
    case CHANGE_FORMAT_SPOT:
      return {...state, formatSpot: action.formatSpot};
    default:
      return state;
  }
}
